/* unplugin-vue-components disabled */import { render } from "./ai-file.vue?vue&type=template&id=76228961&scoped=true"
import script from "./ai-file.vue?vue&type=script&lang=js"
export * from "./ai-file.vue?vue&type=script&lang=js"

import "./ai-file.vue?vue&type=style&index=0&id=76228961&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76228961"],['__file',"src/components/ai-chat/ai-file/ai-file.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76228961"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76228961', __exports__)) {
    api.reload('76228961', __exports__)
  }
  
  module.hot.accept("./ai-file.vue?vue&type=template&id=76228961&scoped=true", () => {
    api.rerender('76228961', render)
  })

}


export default __exports__